module.exports = __webpack_public_path__ + "img/new_3.d3f64fd5.jpeg";